import React, { useState } from 'react';

const ServiceCard = ({ service, index }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`service-card ${isHovered ? 'hovered' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="card-glow"></div>

      <div className="card-header">
        <div className="card-icon">
          <img src={service.icon} alt={`${service.title} icon`} />
        </div>
        <div className="card-number">#{String(index + 1).padStart(2, '0')}</div>
      </div>

      <h3 className="card-title">{service.title}</h3>

      <p className="card-description">{service.description}</p>

      <div className="card-tags">
        {service.tags.map((tag, i) => (
          <span key={i} className="tag">{tag}</span>
        ))}
      </div>


    </div>
  );
};

export default ServiceCard;
